meedy.filter('meedyMomentDate', [
    function() {
        return function(input, format) {
            return moment(input).format(format);
        };
    }
]);